import React, { Component } from 'react';
import { Link, Router, Route, browserHistory } from 'react-router';

import Header from './components/header';
import logo from './logo.svg';
import './App.css';


class Services extends Component {
  render() {
    return (
      <div className="services">
        <div className="container">
          <div className="col-xl-12">
            <h1>Services</h1>
            <h2>Personal</h2>
            <ul>
              <li>Individual and amended tax return preparation</li>
              <li>First Time Abatement for late filing and late payment penalties</li>
              <li>Sale of real property tax projection and consultation</li>
<li>Federal and State estimated taxes</li>
<li>Joint vs Separate tax analysis</li>
<li>1031 Exchange, Notary non-SE income, RSU, ISO, ESPP, Foreign Income Exclusion,
Moving out of California etc.</li>
            </ul>


            <h2>Business</h2>
            <ul>
            <li>Tax returns for Partnership, LLC, S-Corporations and C-Corporations</li>
<li>Late filing penalty waiver for Partnership and S Corporation</li>
<li>Corporate and LLC Dissolutions and Suspension Revival</li>
<li>New business entity consultation</li>
<li>EIN application</li>
<li>Property tax statement Form 571-L processing</li>
            </ul>

            <h2>Trusts and Estates</h2>
            <ul>
              <li>Trust and Estate Fiduciary tax returns</li>
              <li>Federal Estate tax returns Form 706</li>
              <li>Federal and State estimated taxes</li>
              <li>Estate tax planning</li>
              <li>EIN application</li>
<li>Tax effects of sale of properties held by Trust</li>
<li>Stepped-up basis analysis</li>
            </ul>

            <h2>Not-For-Profit</h2>
            <ul>
              <li>Nonprofit tax returns</li>
              <li>Bookkeeping and consulting</li>
            </ul>

            <h2>Accounting Services</h2>
            <ul>
              <li>Sales tax filings</li>
              <li>Payroll services</li>
              <li>Quickbooks setup, training, and accounting</li>
              <li>Bookkeeping and bank reconciliation services</li>
            </ul>

            <h2>All Other Services</h2>
            <ul>
              <li>Audit representation and consulting for IRS, FTB, BOE, EDD</li>
              <li>Audit appeal representation and consulting for IRS, FTB, BOE, EDD</li>
              <li>Internal Revenue code interpretations</li>
            </ul>

          </div>
        </div>
      </div>
    );
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/services.js